module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-51.6968c50b.svg";